import { RecordSource, Store } from 'relay-runtime';
function createStore() {
    var source = new RecordSource();
    var store = new Store(source);
    return store;
}
export { createStore };
//# sourceMappingURL=store.js.map